module.exports = __webpack_public_path__ + "img/spin_btn.2f270cdf.png";